import { render, staticRenderFns } from "./jobs.vue?vue&type=template&id=0019f327&scoped=true&"
import script from "./jobs.vue?vue&type=script&lang=js&"
export * from "./jobs.vue?vue&type=script&lang=js&"
import style0 from "./jobs.vue?vue&type=style&index=0&id=0019f327&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019f327",
  null
  
)

export default component.exports